import { useOrderDetailContext } from '@/context/OrderDetail/OrderDetailContext';
import { useGetOrderDetailEvents } from '@/hooks/order/details/useGetEventHistory';
import { orderEventsResponseToOrderHistoryUi } from '@/hooks/order/details/useGetEventHistory/mapper';
import { useGetOrderDetails } from '@/hooks/order/useGetOrderDetails';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { initialState } from './OrderHistoryUi';

export function useOrderHistoryViewController() {
  const [uiState, setUiState] = useImmer(initialState);

  const orderDetailContext = useOrderDetailContext();
  const orderDetailId = useParams().orderDetailId ?? '';
  const { data: orderDetail } = useGetOrderDetails(orderDetailId);
  const getOrderDetailEventsHook = useGetOrderDetailEvents(orderDetailId);

  useEffect(() => {
    if (!getOrderDetailEventsHook.data) return;
    setUiState(
      orderEventsResponseToOrderHistoryUi(
        getOrderDetailEventsHook.data,
        orderDetail
      )
    );
  }, [getOrderDetailEventsHook.data, orderDetail]);

  const onCloseClicked = () => {
    orderDetailContext.setShowHistoryDialog?.(false);
  };

  return {
    uiState,
    actions: { onCloseClicked },
  };
}
